import { render, staticRenderFns } from "./QuoteTable.vue?vue&type=template&id=1c7e974a&scoped=true"
import script from "./QuoteTable.vue?vue&type=script&lang=js"
export * from "./QuoteTable.vue?vue&type=script&lang=js"
import style0 from "./QuoteTable.vue?vue&type=style&index=0&id=1c7e974a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7e974a",
  null
  
)

export default component.exports